import { jsx as _jsx } from "react/jsx-runtime";
import { useRoute } from 'ziggy-js';
import { Ziggy } from '@/ziggy.js';
;
import ProgressSteps from '@/Jetstream/ProgressSteps';
function classNames() {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(Boolean).join(' ');
}
export default function Progress(_a) {
    var step = _a.step, team = _a.team, branch = _a.branch, certificate = _a.certificate, onChange = _a.onChange;
    var route = useRoute(Ziggy);
    var steps = [
        {
            name: 'Upload EHC',
            description: 'Upload the EHC',
            href: "#",
            status: 'disabled'
        },
        {
            name: 'Details',
            description: 'Review details',
            href: certificate.id ? route('team.branch.certificate.ehc-details', { team: team.id, branch: branch.id, certificate: certificate.id }) : '',
            status: null
        },
        {
            name: 'Horses',
            description: 'Add horse details',
            href: certificate.id ? route('team.branch.certificate.ehc-horses', { team: team.id, branch: branch.id, certificate: certificate.id }) : '',
            status: null
        },
        {
            name: 'Attestations',
            description: 'Enter attestation information',
            href: certificate.id ? route('team.branch.certificate.ehc-attestation', { team: team.id, branch: branch.id, certificate: certificate.id }) : '',
            status: null
        },
        {
            name: 'Generate',
            description: 'Review summary and generate the EHC for download.',
            href: certificate.id ? route('team.branch.certificate.ehc-generate-step', { team: team.id, branch: branch.id, certificate: certificate.id }) : '',
            status: null
        },
    ];
    for (var i = 0; i < steps.length; i++) {
        var _step = steps[i];
        if (i === step) {
            _step.status = 'current';
        }
        if (i > step) {
            _step.status = 'upcoming';
        }
        if (i < step) {
            _step.status = 'complete';
        }
    }
    return (_jsx(ProgressSteps, { step: step, team: team, branch: branch, certificate: certificate, onChange: onChange, steps: steps }));
}
